import * as React from "react"
const WorkshopPeopleIconMoblie = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.125}
      d="M.875 11.5v-1.125a2.25 2.25 0 0 1 2.25-2.25h2.25a2.25 2.25 0 0 1 2.25 2.25V11.5m.563-10.052a2.25 2.25 0 0 1 0 4.36M11 11.5v-1.125a2.25 2.25 0 0 0-1.688-2.166M2 3.625a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z"
    />
  </svg>
)
export default WorkshopPeopleIconMoblie
